import { render, staticRenderFns } from "./HeroBanner.vue?vue&type=template&id=54126f1a"
import script from "./HeroBanner.vue?vue&type=script&lang=ts"
export * from "./HeroBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports